import { APICfg } from 'services/api/api'
import { getId } from 'services/utils'
import { parseLogistic } from '../logistic'
import { upsellingParse, upsellingWrite } from '../upselling'
import { APIFoodUpselling } from './types/api/response-models'
import { FoodUpselling } from './types/internal/foodUpselling-models'

// ============
// PARSE
// ============

export const parseFoodUpselling = (res: APIFoodUpselling): FoodUpselling => {
  const logistics = res.logistics?.map(getId) ?? []
  const logisticsFull = res.logistics?.map(parseLogistic) ?? []

  return {
    ...upsellingParse(res),
    logistics,
    logisticsFull,
  }
}

// ============
// CFG
// ============

const apiCfg: APICfg = {
  endpoint: 'foodupselling',
  parse: parseFoodUpselling,
  write: upsellingWrite,
}

export default apiCfg
